<form>
    <nb-card>
        <nb-card-header>
            <div class="title">
                Signature
            </div>
        </nb-card-header>
        <nb-card-body>
            <div class="signature-area">
                <de-signature-pad #signature [options]="signaturePadOptions"></de-signature-pad>
            </div>

        </nb-card-body>
        <nb-card-footer>
            <div class="row justify-content-center div-card-footer">
                <div>
                    <button nbButton status="primary" class="button-save" (click)="save()" type="button">
                        Yes
                    </button>
                </div>
                <div>
                    <button nbButton status="info" class="button-cancel" (click)="cancel()" type="button">
                        No
                    </button>
                </div>
            </div>
        </nb-card-footer>
    </nb-card>
</form>